<template>
   <!-- Page Content -->
        <div id='page-wrapper'>
          <vue-element-loading size='64' is-full-screen :active='isLoadingData' text='جارى تحميل البيانات' spinner='bar-fade-scale' color='#A4A4A4'/>
          <vue-element-loading size='64' is-full-screen :active='isLoadingForm' text='جارى تحميل بيانات العميل' spinner='bar-fade-scale' color='#A4A4A4'/>
            <div class='container-fluid'>
                <div class='row'>
                    <div class='col-lg-12'>
                        <h1 class='page-header'>إصدار ايصالات</h1>
                    </div>
                    <!-- /.col-lg-12 -->
                </div>
                <!-- /.row -->
                <div class='row'>
                    <div class='col-lg-12'>
                        <div class='panel panel-default'>
                            <div class='panel-heading'>
                            هنا يتم اصدار ايصالات السداد والصيانة للعملاء
                              </div>
                            <!-- /.panel-heading -->
                            <div class='panel-body'>
                              <div class='alert alert-danger alert-dismissable' style="margin: 10px 0px 0px 0px;" v-if='errorShow'>
                                <ul v-if='validationErrors'>
                                    <li v-for='err in validationErrors'  v-bind:key='err.key' v-bind:value='err.key'>{{ err }}</li>
                                </ul>
                              </div>
                              <div class="col-lg-10 col-md-9 col-sm-12">
                              <div class='col-lg-3 col-md-4 col-sm-6'>
                                    <label>الفرع</label>
                                    <select  @change='FillItineraries()' class="form-control"  style="padding: 0px"  v-model="branche">
                                      <option v-for="item in branches" v-bind:key="item.id" v-bind:value="item.id">
                                        {{ item.name }}
                                      </option>
                                    </select>
                              </div>
                              <div class='col-lg-3 col-md-4 col-sm-6'>
                                <label>المنطقة:</label>
                                <select class="form-control" style="padding: 0px" v-model="region_id">
                                  <option v-for="item in regions" v-bind:key="item.id" v-bind:value="item.id">
                                    {{ item.region_name }}
                                  </option>
                                </select>
                              </div>
                              <div class='col-lg-3 col-md-4 col-sm-6'>
                                <div class="form-group">
                                  <label>الاسم/الشهرة</label>
                                  <input v-model='name' class='form-control' name='nickname' type='text'>
                                </div>
                              </div>
                              <div class='col-lg-3 col-md-4 col-sm-6' style="padding: 0px 5px">
                                <div class="form-group">
                                  <label>رقم المحمول</label>
                                  <input v-model='mobile' class='form-control' name='nickname' type='text'>
                                </div>
                              </div>
                              <div class='col-lg-3 col-md-4 col-sm-6'>
                                <div class="form-group">
                                  <label>المحافظة</label>
                                  <select  @change='FillCitys()' class="form-control" style="padding: 0px" v-model="governorate">
                                    <option v-for="(item) in governorates" v-bind:key="item.id" v-bind:value="item.id">
                                      {{ item.name }}
                                    </option>
                                  </select>
                                </div>
                              </div>
                              <div class='col-lg-3 col-md-4 col-sm-6'>
                                <div class="form-group">
                                  <label>المدينة/المركز</label>
                                  <vue-element-loading size='32' :active='isLoadingCitys' spinner='bar-fade-scale' color='#A4A4A4'/>
                                  <select class="form-control" style="padding: 0px" v-model="city">
                                    <option v-for="(city) in cities" v-bind:key="city.id" v-bind:value="city.id">
                                      {{ city.name }}
                                    </option>
                                  </select>
                                </div>
                              </div>
                              <div class='col-lg-6 col-md-8 col-sm-6' style="padding: 0px 5px">
                                <div class="form-group">
                                  <label>القرية العنوان</label>
                                  <input v-model='village' class='form-control' name='nickname' type='text'>
                                </div>
                              </div>
                              <div class='col-lg-2 col-md-2 col-sm-6'>
                                <div class="form-group">
                                  <label>المديونية</label>
                                  <select class="form-control"  style="padding: 0px"  v-model="balance">
                                    <option value='0'></option>
                                    <option value='1'>مدين</option>
                                    <option value='2'>غير مدين</option>
                                  </select>
                                </div>
                              </div>
                              <div class='col-lg-2 col-md-2 col-sm-6'>
                                <div class="form-group">
                                  <label>التقييم</label>
                                  <select class="form-control"  style="padding: 0px" v-model="evaluation">
                                    <option value='0'></option>
                                    <option value='1'>غير مقيم</option>
                                    <option value='2'>سيئ جدا</option>
                                    <option value='3'>سيئ</option>
                                    <option value='4'>جيد</option>
                                    <option value='5'>جيد جدا</option>
                                  </select>
                                </div>
                              </div>
                              <div class='col-lg-2 col-md-2 col-sm-6'>
                                <div class="form-group">
                                  <label>الحالة</label>
                                  <select class="form-control"  style="padding: 0px" v-model="isActive">
                                    <option value='0'></option>
                                    <option value='2'>نشط</option>
                                    <option value='1'>غير نشط</option>
                                  </select>
                                </div>
                              </div>
                              <div class='col-lg-2 col-md-2 col-sm-6'>
                                <div class="form-group">
                                  <label>الترتيب</label>
                                  <select class="form-control"  style="padding: 0px" v-model="sorte">
                                    <option value='customers.rec_id'></option>
                                    <option value='customers.id'>الكود</option>
                                    <option value='customers.branche_id'>الفرع</option>
                                    <option value='line_id'>الخط</option>
                                    <option value='region_id'>المنطقة</option>
                                    <option value='village'>القرية</option>
                                    <option value='rec_id'>السجل</option>
                                    <option value='customers.name'>الاسم</option>
                                    <option value='evaluation'>التقييم</option>
                                    <option value='customers.balance'>الرصيد</option>
                                  </select>
                                </div>
                              </div>
                              <div class='col-lg-2 col-md-2 col-sm-2'>
                                <div class="form-group">
                                  <label>النوع</label>
                                  <div class="form-group input-group">
                                      <span class="input-group-addon"><input type="checkbox" v-model="isInLimit"></span>
                                      <select @change='changeType()' class="form-control"  style="padding: 0px" v-model="type">
                                        <option v-for="item in callTypes" v-bind:key="item.id" v-bind:value="item.id">
                                          {{item.name}}
                                        </option>
                                      </select>
                                    </div>
                                  </div>
                              </div>
                              <div class='col-lg-1 col-md-1 col-sm-6' style="padding: 0px 5px">
                                  <label>من رقم</label>
                                  <input @change="repetTo()" v-model='from_id' class='form-control' name='nickname' type='text'>
                              </div>
                              <div class='col-lg-1 col-md-1 col-sm-6' style="padding: 0px 5px">
                                <div class="form-group">
                                  <label>الى رقم</label>
                                  <input v-model='to_id' class='form-control' name='nickname' type='text'>
                                </div>
                              </div>
                              <div v-show='type == 1 || type == 2' class='col-lg-2 col-md-2 col-sm-6'>
                                <tbDate :today='today' :mytitle='fromTitle' v-model= 'from_date' ></tbDate>
                              </div>
                              <div v-show='type == 1 || type == 2' class='col-lg-2 col-md-2 col-sm-6'>
                                <tbDate :today='today' :mytitle='toTitle' v-model= 'to_date' ></tbDate>
                              </div>
                              <div v-show='type === 3' class='col-lg-2 col-md-2 col-sm-6'>
                                <label>العرض:</label>
                                <select class="form-control" style="padding: 0px" v-model="offer_id">
                                  <option  v-for="offer in offers" v-bind:key="offer.id"  v-bind:value="offer.id">
                                    {{offer.offer_name}} - {{offer.price}}
                                  </option>
                                </select>
                              </div>
                              <div class='col-lg-3 col-md-4 col-sm-6'>
                                <label>&nbsp;</label>
                                <button @click='GetData()' type='button' class='btn btn-outline btn-primary btn-lg btn-block' style='padding:3px'>
                                  <b> عرض </b>
                                </button>
                              </div>
                              <div class='col-lg-3 col-md-4 col-sm-6'>
                                <label>&nbsp;</label>
                                <button v-simple-print="'RecepitTable'" type='button' class='btn btn-outline btn-primary btn-lg btn-block' style='padding:3px'>
                                  <b> طباعة </b>
                                </button>
                              </div>
                            </div>
                            <div class="col-lg-2 col-md-3 col-sm-12" style="padding: 0px">
                              <!-- /.panel -->
                              <div class="chat-panel panel panel-default" >
                                  <div class="panel-heading">
                                     الخطوط
                                  </div>
                                  <!-- /.panel-heading -->
                                  <div class="panel-body" style="padding: 5px">
                                    <div v-for="(item,index) in lines" v-bind:key="index" >
                                      <input @click="FillRegions($event)" :id="index" type="checkbox" :value="item.id" v-model="selectedLine">{{' ' + item.name }}
                                    </div>
                                  </div>
                                  <!-- /.panel-body -->
                              </div>
                        </div>
                              <div style="padding:10px" id="RecepitTable">
                                <div v-if="type == 1" >
                                <table
                                       width="100%"
                                       class="table table-striped table-bordered table-hover"
                                       id="dataTables-example">
                                  <thead>
                                    <tr>
                                      <th rowspan="2" style="width:50px"></th>
                                      <th rowspan="2">م</th>
                                      <th rowspan="2">السجل</th>
                                      <th rowspan="2">الاسم</th>
                                      <th rowspan="2">قيمة الأقساط</th>
                                      <th rowspan="2">عدد الأقساط</th>
                                      <th rowspan="2">المدفوع</th>
                                      <th rowspan="2">تاريخ الاستحقاق</th>
                                      <th colspan="2">آخر إيصال</th>
                                      <th colspan="2">آخر عملية سداد</th>
                                      <th rowspan="2">الاجراء</th>
                                    </tr>
                                    <tr>
                                      <th>التاريخ</th>
                                      <th>الحالة</th>
                                      <th>التاريخ</th>
                                      <th>منذ</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <template v-for="(customer,index) in groupedRecords">
                                    <tr :class="{
                                        fcolor: customer.type_id == 0,
                                        successRow: customer.status == 0 || customer.status == 2
                                      }"
                                        class="odd gradeX"
                                        :key="customer.uid">
                                        <td>
                                          <button v-if="customer.installments.length > 1"
                                                  class="expand-btn"
                                                  :class="{open: expandedRows[customer.uid]}"
                                                  @click="toggleRow(customer.uid)">
                                            {{ expandedRows[customer.uid] ? '−' : '+' }}
                                          </button>
                                          <span v-else></span>
                                        </td>
                                      <td>{{index +1 }}</td>
                                      <td>{{customer.rec_id}}</td>
                                      <td style="text-align:right">
                                        <a
                                          v-show="$per.value.getAllCustomerData"
                                          href="#"
                                          @click.prevent="openCustomerData(customer.uid, customer)">
                                          {{customer.name}}
                                        </a>
                                        </td>
                                      <td>{{customer.total_amount}}</td>
                                      <td>{{ customer.installments.length }}</td>
                                      <td>{{customer.total_paid}}</td>
                                      <td>{{customer.first_due_date}}</td>
                                      <td>{{customer.r_created_at}}</td>
                                      <td>{{customer.status_label}}</td>
                                      <td>{{customer.last_payment_date}}</td>
                                      <td>{{customer.last_payment_days_diff}}</td>
                                      <td>
                                        <button
                                            @click="GetAllCustomerData(customer.uid, customer.contract_offer_id, customer.type)"
                                            type="button"
                                            class="btn btn-outline btn-info btn-xs"
                                            data-toggle="modal"
                                            data-target="#ContractsForm">
                                            عرض
                                        </button>
                                      </td>

                                    </tr>
                                    <!-- التفاصيل -->
                                      <tr :key="'details-' + customer.uid">
                                        <td colspan="10" style="padding:0;border-top:0">

                                          <transition name="fade">

                                            <div v-if="expandedRows[customer.uid]" class="detail-wrapper">

                                              <table class="table table-sm table-bordered detail-table">

                                                <thead>
                                                  <tr>
                                                    <th>قيمة القسط</th>
                                                    <th>المدفوع</th>
                                                    <th>المتبقي</th>
                                                    <th>تاريخ الاستحقاق</th>
                                                  </tr>
                                                </thead>

                                                <tbody>
                                                  <tr v-for="(item,i) in customer.installments"
                                                      :key="i"
                                                      class="detail-row">
                                                    <td>{{ item.amount }}</td>
                                                    <td>{{ item.total_paid }}</td>
                                                    <td>{{ item.amount - item.total_paid }}</td>
                                                    <td>{{ item.due_date }}</td>
                                                  </tr>
                                                </tbody>

                                              </table>

                                            </div>

                                          </transition>

                                        </td>
                                      </tr>
                                    </template>
                                  </tbody>

                                </table>

                                </div>

                                <table v-else width='100%' class='table table-striped table-bordered table-hover' id='dataTables-example'>
                                  <thead>
                                    <tr>
                                      <th style='padding:2px;text-align: center'>م</th>
                                      <th style='padding:2px;text-align: center'>السجل</th>
                                      <th style='padding:2px;text-align: center'>الاسم</th>
                                      <th style='padding:2px;text-align: center'>المنطقة</th>
                                      <th style='padding:2px;text-align: center'>القرية</th>
                                      <th style='padding:2px;text-align: center'>المحمول</th>
                                      <th v-show='type == 2' style='padding:2px;text-align: center'>التاريخ</th>
                                      <th v-show='type == 2' style='padding:2px;text-align: center'>الأصناف</th>
                                      <th v-show='type == 2' style='padding:2px;text-align: center'>المديونية</th>
                                      <th v-show='type == 2' style='padding:2px;text-align: center'>آخر دفع</th>
                                      <th v-show='type == 2' style='padding:2px;text-align: center'>النوع</th>
                                      <th v-show='type == 1' style='padding:2px;text-align: center'>العدد</th>
                                      <th v-show='type == 1' style='padding:2px;text-align: center'>الاجمالى</th>
                                      <th v-show='type == 3' style='padding:2px;text-align: center'>المديونية</th>
                                      <th v-show='type != 2' style='padding:2px;text-align: center'>آخر اتصال</th>
                                      <th style='padding:2px;text-align: center'>الاجراء</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                      <tr :class="{fcolor :record.type_id == 0}" class='odd gradeX' v-for='(record,index) in records' :key='index'>

                                         <td align='center'>{{index +1 }}</td>
                                         <td align='center'>{{record.rec_id}}</td>
                                         <td align='center'>{{record.name}}</td>
                                         <td align='center'>{{record.region_name}}</td>
                                         <td align='center'>{{record.village}}</td>
                                        <td align='center'>{{record.mobile}} {{record.mobile2}}</td>
                                        <td v-show='type == 2' align='center'>{{record.next_change}}</td>
                                        <td v-show='type == 2' align='center'>{{record.items}}</td>
                                        <td v-show='type == 2' align='center'>{{record.balance}}</td>
                                        <td v-show='type == 2' align='center'>{{record.last_paid_date}}</td>
                                        <td v-show='type == 2' align='center'>{{record.last_paid_type}}</td>
                                        <td v-show='type == 1' align='center'>{{record.count}}</td>
                                        <td v-show='type == 1' align='center'>{{record.total_reset}}</td>
                                        <td v-show='type == 3' align='center'>{{record.balance}}</td>
                                        <td v-show='type != 2' align='center' data-toggle="tooltip" data-placement="top" :title="record.tooltip">{{record.notes}}</td>
                                        <td align='center'>
                                          <button @click='GetAllCustomerData(record.uid, record.contract_offer_id, record.type)' type='button' class='btn btn-outline btn-info btn-xs' data-toggle='modal' data-target='#ContractsForm'>عرض</button>
                                        </td>
                                      </tr>
                                  </tbody>
                              </table>
                            </div>
                                <!-- /.table-responsive -->
                            </div>
                            <!-- /.panel-body -->
                        </div>
                        <!-- /.panel -->
                    </div>
                    <!-- /.col-lg-12 -->
                </div>
             </div>
             <!-- ================ Contracts Modal Begin ======================================== -->
             <CustomerDetails ref="CustomerDetails"  @return-data="returnData"> </CustomerDetails>
           <!-- ================  /.modal-content ======================================== -->
             <!-- ================ Contracts Modal Begin ======================================== -->
             <div class="modal fade" id="ContractsForm" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
                 <div class="modal-dialog modal-lg">
                     <div class="modal-content">
                         <div class="modal-header">
                             <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
                             <h4 class="modal-title" id="myModalLabel">{{contTitle}}</h4>
                         </div>
                         <div class="modal-body">
                           <div class="panel-body" style="padding:0px">

                            <vue-tabs active-tab-color="#6DBCF1"
                                      active-text-color="white"
                                      centered
                                      v-model="tabName"
                                      @tab-change="handleTabChange">
                                      <v-tab v-if='type === 1' title="إصدار" icon="ti-user">
                                      <CreateDailyReceipts01 :callMethod = "callme" ref="CreateDailyReceipts01"> </CreateDailyReceipts01>
                                      </v-tab>
                                      <v-tab v-if='type === 2' title="إصدار" icon="ti-user">
                                      <CreateDailyReceipts02 :callMethod = "callme" ref="CreateDailyReceipts02"> </CreateDailyReceipts02>
                                      </v-tab>
                                      <v-tab v-if='type === 3' title="إصدار" icon="ti-user">
                                      <CreateDailyReceipts03 :callMethod = "callme" ref="CreateDailyReceipts03"> </CreateDailyReceipts03>
                                      </v-tab>
                              <v-tab title="البيانات" icon="ti-user">
                              <Data ref="Data"> </Data>
                                </v-tab>
                               <v-tab :disabled="disabled" id = "1" title="العقود" icon="ti-settings">
                                 <Contracts ref="Contracts"> </Contracts>
                               </v-tab>
                               <v-tab :disabled="disabled"  id = "2" title="السداد" icon="ti-check">
                                 <InstallmentPaymrnt ref="InstallmentPaymrnt"> </InstallmentPaymrnt>
                               </v-tab>
                               <v-tab :disabled="disabled" id="3" title="الصيانة" icon="ti-check">
                                 <Maintenance  ref="Maintenance"> </Maintenance>
                               </v-tab>
                               <v-tab :disabled="disabled" id="4" title="جدولة" icon="ti-check">
                                 <MaintenanceSchedule  ref="MaintenanceSchedule"> </MaintenanceSchedule>
                               </v-tab>
                               <v-tab :disabled="disabled"  id="5" title="المتحصلات" icon="ti-check">
                                 <Receipts  ref="Receipts"> </Receipts>
                               </v-tab>
                               <v-tab :disabled="disabled"  id="7" title="العروض" icon="ti-check">
                                 <OM  ref="OM"> </OM>
                               </v-tab>
                               <v-tab  :disabled="disabled" id = "8" title="المكالمات" icon="ti-check">
                                 <CallLogs  ref="CallLogs"> </CallLogs>
                               </v-tab>
                           </vue-tabs>
                         </div>
<!-- //////////////////////////////////.panel-heading -->
                               <!-- Nav tabs -->

                           <!-- /.panel-body -->
                         </div>
                         <div style="align-content: center;" class="modal-footer">
                             <button type="button" class="btn btn-default" data-dismiss="modal">خروج</button>
                         </div>
                     </div>
                 </div>
                 <!-- /.modal-dialog -->
             </div>
    <!-- ================  /.modal-content ======================================== -->
             <!-- /. Contracts modal End -->
             <!-- /.container-fluid -->
        </div>
</template>
<style scoped>
.successRow {
    background-color: #e6f4ea !important; /* أخضر فاتح مريح */
}
/* زر التوسيع */
.expand-btn {
    width: 26px;
    height: 26px;
    border-radius: 50%;
    border: none;
    background: #0d6efd;
    color: white;
    font-weight: bold;
    font-size: 14px;
    line-height: 26px;
    transition: all 0.25s ease;
}

.expand-btn.open {
    background: #dc3545;
    transform: rotate(180deg);
}

/* تفاصيل */
.detail-wrapper {
    overflow: hidden;
    transition: all 0.3s ease;
}

.detail-table {
    width: 100%;
    margin: 0;
    background: #fff;
}

.detail-table th {
    background: #e9ecef;
}

.detail-row {
    background: #ffffff;
}

.detail-row:hover {
    background: #f6f8fa;
}
/* الصف الأول */
#dataTables-example thead tr:first-child th {
    position: sticky;
    top: 60px;                 /* يقف عند 60px */
    background: #f8f9fa;
    z-index: 10;
}

/* الصف الثاني */
#dataTables-example thead tr:nth-child(2) th {
    position: sticky;
    top: 84px;                 /* 60 + ارتفاع الصف الأول (تقريبًا 38px) */
    background: #e9ecef;
    z-index: 9;
}

/* تنسيق عام */
#dataTables-example th,
#dataTables-example td {
    padding: 2px;
    text-align: center;
    vertical-align: middle;
}
.fcolor {
   color: #CC0000;
}
.disabled {
    pointer-events: none;
    cursor: default;
    color: gray;
}
</style>
<script>
import Swal from 'sweetalert2'
import CreateDailyReceipts01 from '@/components/Sales/CreateDailyReceipts01'
import CreateDailyReceipts02 from '@/components/Sales/CreateDailyReceipts02'
import CreateDailyReceipts03 from '@/components/Sales/CreateDailyReceipts03'
import CreateDailyReceipts04 from '@/components/Sales/CreateDailyReceipts04'
import OM from '@/components/Sales/Contracts/OM'
import Contracts from '@/components/Sales/Contracts/Contracts'
import InstallmentPaymrnt from '@/components/Sales/Contracts/InstallmentPaymrnt'
import Data from '@/components/Sales/Contracts/Data'
import Maintenance from '@/components/Sales/Contracts/Maintenance'
import CallLogs from '@/components/Sales/Contracts/CallLogs'
import Receipts from '@/components/Sales/Contracts/Receipts'
import MaintenanceSchedule from '@/components/Sales/Contracts/MaintenanceSchedule'
import axios from 'axios'
import tbDate from '@/components/myComponents/tbDate'
import CustomerDetails from '@/components/Sales/Customers/CustomerDetails'
export default {
  name: 'createCollectingstatement',
  components: {
    OM,
    Contracts,
    InstallmentPaymrnt,
    Maintenance,
    CallLogs,
    Receipts,
    CreateDailyReceipts01,
    CreateDailyReceipts02,
    CreateDailyReceipts03,
    CreateDailyReceipts04,
    MaintenanceSchedule,
    Data,
    tbDate,
    CustomerDetails
  },
  data () {
    return {
      expandedRows: {},
      callTypes: [
        {id: 1, name: 'سداد قسط فلتر'},
        {id: 2, name: 'صيانة (سداد/تغيير)'},
        {id: 3, name: 'عرض / طلب صيانة'}
      ],
      today: true,
      isInLimit: false,
      dateTitle: 'التاريخ',
      fromTitle: 'من تاريخ',
      toTitle: 'الى تاريخ',
      from_date: '',
      to_date: '',
      emptyRec: [{id: 0, name: 0}],
      validationErrors: '',
      offers: {},
      pagination: {},
      region_id: {},
      regions: '',
      records: [],
      lines: {},
      line: '',
      selectedLine: [],
      record: {},
      offer_id: '',
      recItems: [],
      printRecord: [],
      errorShow: false,
      successShow: false,
      isLoadingData: false,
      isLoadingForm: false,
      isLoadingDelete: false,
      isLoadingCitys: false,
      printRecords: [],
      branches: {},
      governorates: {},
      cities: {},
      itineraries: {},
      tabName: 'إدراج',
      title: '',
      disabled: true,
      id: '',
      name: '',
      contTitle: '',
      branche: 0,
      brancheID: 0,
      itinerarie: 0,
      notes: '',
      governorate: '',
      city: '',
      village: '',
      isActive: '',
      balance: '',
      sorte: 'rec_id',
      evaluation: '',
      mobile: '',
      from_id: '',
      to_id: '',
      type: 1
    }
  },
  computed: {
    groupedRecords () {
      const map = {}
      this.records.forEach(item => {
        if (!map[item.uid]) {
          map[item.uid] = {
            uid: item.uid,
            rec_id: item.rec_id,
            name: item.name,
            id: item.id,
            branche_id: item.branche_id,
            line_id: item.line_id,
            region_id: item.region_id,
            user_id: item.user_id,
            rec_id_letter: item.rec_id_letter,
            rec_id_backup: item.rec_id_backup,
            nickname: item.nickname,
            governorate: item.governorate,
            city: item.city,
            village: item.village,
            address: item.address,
            mobile: item.mobile,
            mobile2: item.mobile2,
            idcard: item.idcard,
            active: item.active,
            balance: item.balance,
            notes: item.notes,
            evaluation: item.evaluation,
            location: item.location,
            maintenance_group_id: item.maintenance_group_id,
            reviewType: item.reviewType,
            created_at: item.created_at,
            updated_at: item.updated_at,
            total_amount: 0,
            total_paid: 0,
            first_due_date: item.due_date,
            status_label: item.status_label,
            last_payment_date: item.last_payment_date,
            last_payment_days_diff: item.last_payment_days_diff,
            r_created_at: item.r_created_at,
            type: item.type,
            status: item.status,
            installments: [],
            open: false
          }
        }
        // تجميع المبالغ
        map[item.uid].total_amount += Number(item.amount)
        map[item.uid].total_paid += Number(item.total_paid)

        // تحديد أول وآخر تاريخ استحقاق
        if (item.due_date < map[item.uid].first_due_date) {
          map[item.uid].first_due_date = item.due_date
        }
        // إضافة القسط للتفاصيل
        map[item.uid].installments.push({
          amount: item.amount,
          total_paid: item.total_paid,
          due_date: item.due_date
        })
      }
      )
      return Object.values(map)
    }
  },
  mounted: function () {
    this.$root.$on('Update_Totals', (id, ind, mai, total, contractId, balance) => {
      let i = this.records.findIndex(x => x.id === parseInt(id))
      if (i > -1) {
        this.records[i].balance = balance
        this.$refs.Contracts.updateTotal(contractId, ind, mai)
      }
    })
    this.$root.$on('SET_Title', (Title) => {
      this.contTitle = Title
    })
    this.$root.$on('SET_Records', (RecordData, Type) => {
      this.disabled = false
      this.$refs.Contracts.UpdateData(RecordData.branche_id)
      this.$refs.InstallmentPaymrnt.UpdateData(RecordData.branche_id)
      this.$refs.Maintenance.UpdateData(RecordData.branche_id)
      this.$refs.receipt.UpdateData(RecordData.branche_id)
      if (Type === 0) {
        this.records.push(RecordData)
      } else {
        let i = this.records.map(record => record.id).indexOf(RecordData.id)
        this.records.splice(i, 1, RecordData)
      }
      this.$refs.Contracts.GetData()
    })
  },
  created () {
    this.governorates = JSON.parse(localStorage.getItem('Gov'))
    this.governorates.unshift(this.emptyRec)
    this.branches = JSON.parse(localStorage.getItem('Branches'))
    this.brancheID = localStorage.getItem('BrancheID')
    this.branche = this.branches[0].id
    this.FillItineraries()
  },
  methods: {
    callme (data) {
      let i = this.records.findIndex(x => x.contract_offer_id === data)
      if (this.type === 1) {
        this.records[i].type = 1
        this.records[i].status_label = 'تم الاصدار'
      } else {
        this.records.splice(i, 1)
      }
    },
    repetTo () {
      this.to_id = this.from_id
    },
    changeType () {
      this.records = []
    },
    // ===========================================================================
    getOffres (branch) {
      this.isLoadingData = true
      axios.post(this.$apiURL + 'getAllActiveOffers', {
        token: localStorage.getItem('token'),
        branch: branch
      })
        .then(({ data }) => {
          this.offers = data
          this.isLoadingData = false
        })
    },
    // ===========================================================================
    FillItineraries () {
      this.line = ''
      this.regions = ''
      this.region_id = ''
      let i = this.branches.findIndex(x => x.id === parseInt(this.branche))
      if (i > -1) {
        this.brancheID = i
        this.lines = JSON.parse(JSON.stringify(this.branches[i].itineraries))
        this.line = 0
      }
    },
    // ===========================================================================
    FillRegions (e) {
      this.$nextTick(() => {
        var id = (this.selectedLine[0])
        this.regions = ''
        this.region_id = ''
        if (id != null && id.length !== 0) {
          let i = this.branches[this.brancheID].itineraries.findIndex(x => x.id === parseInt(id))
          if (i > -1) {
            this.regions = JSON.parse(JSON.stringify(this.branches[this.brancheID].itineraries[i].regions))
            this.regions.unshift(this.emptyRec)
          }
        }
      })
    },
    // ===========================================================================
    FillCitys () {
      this.isLoadingCitys = true
      this.city = ''
      axios.post(this.$apiURL + 'get-branch-cities', {
        token: localStorage.getItem('token'),
        governorate: this.governorate
      })
        .then(res => {
          this.isLoadingCitys = false
          this.cities = res.data
          this.cities.unshift(this.emptyRec)
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
        })
    },
    // ===========================================================================
    saveNots () {
      this.isLoadingData = true
      axios.post(this.$apiURL + 'saveNotes', {
        token: localStorage.getItem('token'),
        notes: this.notes,
        id: this.$store.state.customerData.id
      })
        .then(({ data }) => {
          this.isLoadingData = false
        })
    },
    // ===========================================================================
    toggleRow (uid) {
      this.$set(
        this.expandedRows,
        uid,
        !this.expandedRows[uid]
      )
    },
    // ===========================================================================
    GetData () {
      var Url = ''
      if (this.type === 1) {
        Url = 'get-data-receipt01'
      } else if (this.type === 2) {
        Url = 'get-data-receipt02'
      } else if (this.type === 3) {
        Url = 'get-data-receipt03'
      } else if (this.type === 4) {
        Url = 'get-data-receipt04'
      } else {
        Url = 'GetMaintenanceCollectingSheetData'
      }
      this.isLoadingData = true
      axios.post(this.$apiURL + Url, {
        token: localStorage.getItem('token'),
        line_id: this.selectedLine,
        branch_id: this.branche,
        region_id: this.region_id,
        name: this.name,
        governorate: this.governorate,
        city: this.city,
        village: this.village,
        mobile: this.mobile,
        date_from: this.from_date,
        date_to: this.to_date,
        evaluation: this.evaluation,
        isActive: this.isActive,
        from_id: this.from_id,
        type: this.type,
        to_id: this.to_id,
        offer_id: this.offer_id,
        balance: this.balance,
        isInLimit: this.isInLimit,
        sorte: this.sorte
      })
        .then(({ data }) => {
          this.records = data.data
          this.recItems = data.items
          this.isLoadingData = false
          this.successShow = true
          this.errorShow = false
        })
        .catch(err => {
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          if (err.response.status === 401) {
            this.$router.push('login')
          }
          this.validationErrors = err.response.data.errors
          this.successShow = false
          this.errorShow = true
          this.isLoadingData = false
        })
    },
    // ===========================================================================
    returnData () {
      // Dont Delete It ####
    },
    // ===========================================================================
    openCustomerData (uid, rec) {
      this.$refs.CustomerDetails.setData(uid, rec)
    },
    // ===========================================================================
    handleTabChange (tabIndex, newTab, oldTab) {
      if (newTab.id === '1') {
        this.$refs.Contracts.tabSelected()
      } else if (newTab.id === '2') {
        this.$refs.InstallmentPaymrnt.tabSelected(1)
      } else if (newTab.id === '3') {
        this.$refs.Maintenance.tabSelected()
      } else if (newTab.id === '4') {
        this.$refs.MaintenanceSchedule.tabSelected()
      } else if (newTab.id === '5') {
        this.$refs.Receipts.tabSelected()
      } else if (newTab.id === '7') {
        this.$refs.OM.tabSelected()
      } else if (newTab.id === '8') {
        this.$refs.CallLogs.tabSelected()
      }
    },
    // ================================================================================
    async GetAllCustomerData (uid, offeID, type) {
      this.type = parseInt(type)
      this.isLoadingForm = true
      this.tabName = 'إصدار ايصال'
      try {
        const res = await axios.post(this.$apiURL + 'getAllCustomerData', {
          token: localStorage.getItem('token'),
          uid: uid
        })
        this.isLoadingForm = false
        this.$store.dispatch('getAllCustomerData', res.data[0])
        await this.getOffres(res.data[0].branche_id)
        this.disabled = false
        this.contTitle = '[' + 'كود سجل ' + this.$store.state.customerData.rec_id + ']' + this.$store.state.customerData.name + ' ' + '[' + 'العقد ' + this.$store.state.customerData.contract_id + ']'
        // this.$refs.CollectingSheets.GetData(this.from_date, this.to_date, this.branche)
        this.$refs.Data.FillData(uid)
        // -----------------------------
        if (this.$per.value.Contract_show) {
          this.$refs.Contracts.GetData()
        }
        // -----------------------------
        /*
        if (this.$per.value.Maintenance_show) {
          this.$refs.Maintenance.GetData()
        }
        */
        // -----------------------------
        if (this.$per.value.InstallmentPaymrnt_show) {
          this.$refs.InstallmentPaymrnt.GetData()
        }
        // -----------------------------
        if (this.$per.value.Notes_show) {
          this.notes = this.$store.state.customerData.notes
        }
        if (type === 1) {
          this.$refs.CreateDailyReceipts01.tabSelected(this.$store.state.customerData.uid, this.from_date, this.to_date, this.type, offeID, this.isInLimit, this.offers, this.recItems)
        } else if (type === 2) {
          this.$refs.CreateDailyReceipts02.tabSelected(this.$store.state.customerData.uid, this.from_date, this.to_date, this.type, offeID, this.isInLimit, this.offers, this.recItems)
        } else if (type === 3) {
          this.$refs.CreateDailyReceipts03.tabSelected(this.$store.state.customerData.uid, this.from_date, this.to_date, this.type, offeID, this.isInLimit, this.offers, this.recItems)
        } else if (type === 4) {
          this.$refs.CreateDailyReceipts04.tabSelected(this.$store.state.customerData.uid)
        }
      } catch (err) {
        if (uid !== 0) {
          if (err.response.data.errors === 'Forbidden') {
            this.$router.push('accessdeny')
          }
          if (err.response.status === 401) {
            this.$router.push('login')
          }
        }
      }
    },
    // =================================================================
    deleteData (uid, id) {
      Swal.fire({
        title: 'هل أنت متأكد',
        text: 'سيتم حذف هذا السجل نهائيا من قاعدة البيانات!',
        icon: 'warning',
        showCancelButton: true,
        cancelButtonColor: '#3085d6',
        confirmButtonColor: '#d33',
        cancelButtonText: 'لا',
        confirmButtonText: 'نعم'
      }).then((result) => {
        if (result.isConfirmed) {
          this.isLoadingDelete = true
          axios.post(this.$apiURL + 'deleteCustomer', {
            token: localStorage.getItem('token'),
            id: uid
          })
            .then(res => {
              Swal.fire({
                position: 'fixed',
                icon: 'success',
                title: 'تم حذف السجل بنجاح',
                showConfirmButton: false,
                timer: 1000
              })
              let i = this.records.map(record => record.id).indexOf(id)
              this.records.splice(i, 1)
              this.isLoadingDelete = false
            })
            .catch(err => {
              if (err.response.data.errors === 'Unauthenticated') {
                this.$router.push('login')
              }
              if (err.response.data.errors === 'Forbidden') {
                this.$router.push('accessdeny')
              }
              this.error = err.message
              this.isLoadingDelete = false
            })
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Sales/CreateReceipts.vue